/* ═══════════════════════════════════════════════════════════════════════════════
   BATI VIZ — Fonctions utilitaires
   ═══════════════════════════════════════════════════════════════════════════════ */

/** Formate un nombre en euros */
export const fmt = (n) =>
  n == null
    ? "—"
    : new Intl.NumberFormat("fr-FR", {
        style: "currency",
        currency: "EUR",
        maximumFractionDigits: 0,
      }).format(n);

/** Formate en euros abrégé (K/M) */
export const fmtK = (n) => {
  if (n == null) return "—";
  if (Math.abs(n) >= 1e6) return (n / 1e6).toFixed(1) + "M €";
  if (Math.abs(n) >= 1e3) return (n / 1e3).toFixed(0) + "K €";
  return fmt(n);
};

/** Calcule le pourcentage d'évolution */
export const pct = (a, b) => (b == null || b === 0 ? null : ((a - b) / Math.abs(b)) * 100);
